import React from "react";
import { Checkbox, Form, Input, InputNumber, Select, Radio } from "antd";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";

const { Option } = Select;

const itemStyles = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const FormElement = (props) => {
  const { control, errors } = props;
  return (
    <>
      <Form.Item
        {...itemStyles}
        label="First Name"
        extra={errors?.first_name?.message}
        required
        validateStatus={errors?.first_name ? "error" : ""}
      >
        <Controller
          name="first_name"
          control={control}
          render={({ field }) => (
            <Input {...field} placeholder="Enter First Name" />
          )}
        />
      </Form.Item>
      <Form.Item
        {...itemStyles}
        label="Last Name"
        extra={errors?.last_name?.message}
        required
        validateStatus={errors?.last_name ? "error" : ""}
      >
        <Controller
          name="last_name"
          control={control}
          render={({ field }) => (
            <Input {...field} placeholder="Enter Last Name" />
          )}
        />
      </Form.Item>
      <Form.Item
        {...itemStyles}
        label="E-mail"
        extra={errors?.email?.message}
        required
        validateStatus={errors?.email ? "error" : ""}
      >
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <Input {...field} placeholder="Enter E-mail" />
          )}
        />
      </Form.Item>
      <Form.Item
        {...itemStyles}
        label="Password"
        extra={errors?.password?.message}
        required
        validateStatus={errors?.password ? "error" : ""}
      >
        <Controller
          name="password"
          control={control}
          render={({ field }) => (
            <Input.Password {...field} placeholder="Enter Password" />
          )}
        />
      </Form.Item>
      <Form.Item {...itemStyles} label="Phone Number">
        <Controller
          name="phone"
          control={control}
          render={({ field }) => (
            <Input {...field} placeholder="Enter Phone Number" />
          )}
        />
      </Form.Item>
      <Form.Item {...itemStyles} label="Preffered time">
        <Controller
          name="work_time"
          control={control}
          render={({ field }) => (
            <Radio.Group {...field}>
              <Radio value="anytime">Any time</Radio>
              <Radio value="9-12">9 - 12</Radio>
              <Radio value="1-5">1 - 5</Radio>
              <Radio value="all_night">All Night</Radio>
              <Radio value="other">Other</Radio>
            </Radio.Group>
          )}
        />
      </Form.Item>
      <Form.Item {...itemStyles} label="Interested in">
        <Controller
          control={control}
          name="interested_in"
          render={({ field }) => (
            <Checkbox.Group
              {...field}
              style={{
                width: "100%",
              }}
            >
              <Checkbox value="A">A</Checkbox>
              <Checkbox value="B">B</Checkbox>
              <Checkbox value="C">C</Checkbox>
              <Checkbox value="D">D</Checkbox>
              <Checkbox value="E">E</Checkbox>
            </Checkbox.Group>
          )}
        />
      </Form.Item>
      <Form.Item
        {...itemStyles}
        label="Age"
        extra={errors?.age?.message}
        required
        validateStatus={errors?.age ? "error" : ""}
      >
        <Controller
          control={control}
          name="age"
          render={({ field }) => (
            <InputNumber {...field} min={1} max={99} step={1} />
          )}
        />
      </Form.Item>
      <Form.Item {...itemStyles} label="Gender">
        <Controller
          control={control}
          name="gender"
          render={({ field }) => (
            <Select placeholder="select your gender" {...field}>
              <Option value="male">Male</Option>
              <Option value="female">Female</Option>
            </Select>
          )}
        />
      </Form.Item>
      <Form.Item {...itemStyles} label="Comments">
        <Controller
          control={control}
          name="comment"
          render={({ field }) => (
            <Input.TextArea {...field} showCount maxLength={100} />
          )}
        />
      </Form.Item>
    </>
  );
};

FormElement.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      message: PropTypes.string,
    }),
  ).isRequired,
};

export default FormElement;
